// Theme/ColorModeContext.js
import { createContext, useContext, useState, useMemo } from 'react';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material';
import { lightColors, darkColors } from './tokens';
import palette from './palette';
import typography from './typography';
import shape from './shape';
import components from './components';

export const ColorModeContext = createContext({
  mode: 'light',
  colors: lightColors,
  toggleColorMode: () => {},
});

export const useColors = () => useContext(ColorModeContext).colors;
export const useColorMode = () => useContext(ColorModeContext);

export function ColorModeProvider({ children }) {
  const [mode, setMode] = useState('light');

  const activeColors = mode === 'dark' ? darkColors : lightColors;
  console.log("acti ",activeColors.primary.main)

  const theme = useMemo(() => {
    const darkPaletteOverride = mode === 'dark' ? {
      mode: 'dark',
      background: {
        default: activeColors.background.default,
        paper: activeColors.background.paper,
      },
      text: {
        primary: activeColors.text.primary,
        secondary: activeColors.text.secondary,
      },
    } : {};

    let t = createTheme({
      typography,
      shape,
      components,
      palette: { ...palette, ...darkPaletteOverride },
    });
    return responsiveFontSizes(t);
  }, [mode]);

  return (
    <ColorModeContext.Provider value={{
      mode,
      colors: activeColors,
      toggleColorMode: () => setMode(m => m === 'light' ? 'dark' : 'light'),
    }}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}